import { sendWebsocketMessage } from '../../../../../../App';
/**
 * This is seperate than a softorder. this is more hardlined to
 * changing configurations of the tradeplan/tactics itself,
 * whereas the softorders are more directed at what composes the current exit price.
 * This probably doesnt make a lot of sense, and it would be easier to show.
 * @param {*} pluginType
 * @param {*} pluginJsonDetails
 * @param {*} pluginName
 * @param {*} tradePlanId
 */
export function updatePlugins(
  //tactic, setup, setup filter
  pluginType,
  /*
  {
    candleDuration: 5,
    ...
  }
  */
  pluginJsonDetails,
  // CANDLE_BREAK
  pluginName,
  //AMD1284989789
  tradePlanId,
  // not used yet, would only exist once there is a soft order, in the future this might change
  tacticId
) {
  const msg = {
    messageType: 'updateTradePlan',
    field: 'updatePlugins',
    tradePlanId,
    value: {
      tacticId,
      pluginType,
      plugin: pluginName,
      details: pluginJsonDetails,
    },
  };
  sendWebsocketMessage(msg);
}
